__turbopack_context__.v({
  "mobileView": "TemplateGallery-module-scss-module__2JMMyW__mobileView",
  "noTagsPadding": "TemplateGallery-module-scss-module__2JMMyW__noTagsPadding",
  "noTagsPaddingLarger": "TemplateGallery-module-scss-module__2JMMyW__noTagsPaddingLarger",
  "templateGalleryContainer": "TemplateGallery-module-scss-module__2JMMyW__templateGalleryContainer",
});
